import { Badge, type BadgeProps } from '@/components/ui/Badge'
import type { WorkflowReadiness } from '@/types/admin'

const readiness: Record<WorkflowReadiness, { label: string; tone: BadgeProps['tone'] }> = {
  ok: { label: 'Ready', tone: 'success' },
  warning: { label: 'Incomplete', tone: 'warning' },
  error: { label: 'Failing', tone: 'danger' },
  unconfigured: { label: 'Not set up', tone: 'neutral' },
}

export const READINESS_FILTERS = [
  { value: 'ok', label: 'Ready' },
  { value: 'warning', label: 'Incomplete' },
  { value: 'error', label: 'Failing' },
  { value: 'unconfigured', label: 'Not set up' },
] as const

export function ReadinessPill({ state }: { state: WorkflowReadiness }) {
  const r = readiness[state] ?? readiness.unconfigured
  return <Badge tone={r.tone} dot>{r.label}</Badge>
}
